import { render } from "./CategoryLink.vue?vue&type=template&id=f02b7b12&scoped=true"
import script from "./CategoryLink.vue?vue&type=script&lang=js"
export * from "./CategoryLink.vue?vue&type=script&lang=js"

import "./CategoryLink.vue?vue&type=style&index=0&id=f02b7b12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f02b7b12"]])

export default __exports__